export default __webpack_public_path__ + "static/media/mobil88.1e7ea6db.svg";